import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { MasterCurrency } from '../interfaces/Currency';

interface CurrencyState {
    currencies: MasterCurrency[];
    multiCurrencies: MasterCurrency[];
    currenciesLoading: boolean;
    setCurrency: (currencies: MasterCurrency[]) => void;
    setMultiCurrencies: (multiCurrencies: MasterCurrency[]) => void;
    setCurrenciesLoading: (currenciesLoading: boolean) => void;
}

export const useCurrencyStore = create<CurrencyState>((set) => ({
    currencies: [],
    multiCurrencies: [],
    currenciesLoading: false,

    setCurrency: (currencies: MasterCurrency[]) => {
        set({ currencies })
    },
    setMultiCurrencies: (multiCurrencies: MasterCurrency[]) => {
        set({ multiCurrencies })
    },
    setCurrenciesLoading: (currenciesLoading: boolean) => {
        set({ currenciesLoading })
    }
}));

